<template>
  <Dialog v-model="dialog" icon="fas fa-trash-alt" :title="$t('COMFIRMATION')">
    <template v-slot:content>削除します。よろしいですか。</template>
    <template v-slot:actions>
      <v-btn color @click="dialog = false" small>{{ $t("CANCEL") }}</v-btn>
      <v-btn
        color="error"
        :disabled="loading"
        :loading="loading"
        small
        @click="handleDelete"
        >{{ $t("OK") }}</v-btn
      >
    </template>
  </Dialog>
</template>

<script>
import { deleteQuestion } from "@/api/Pratice.api";
import Dialog from "@/components/Dialog/Dialog";
export default {
  props: ["item"],
  components: { Dialog },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  methods: {
    async handleDelete() {
      this.loading = true;
      let params = {
        id: this.item.Id,
        sub_key: this.$route.params.drillId,
      };
      await deleteQuestion(params)
        .then(() => {
          this.$emit("resetList");
          this.loading = false;
          this.dialog = false;
        })
        .catch(({ message }) => {
          this.loading = false;
          this.$toast.error(message);
        });
    },
    handleCancel() {
      //   this.$emit("resetList");
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>